module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "uib-tooltip": "Oculta ou Mostra o histórico de alterações da Entidade",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.mostraHistorico = !_vm.mostraHistorico
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.mostraHistorico ? 'Ocultar histórico' : 'Mostrar histórico'))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraHistorico),
      expression: "mostraHistorico"
    }],
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.historicoGridItems,
      "bordered": _vm.table.bordered,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "inicio",
      fn: function(row) {
        return [_vm._v("\n              " + _vm._s(row.value ? _vm.$moment(row.value, 'YYYY-MM-DD HH:mm:ss.SSS').format('L HH:mm:ss') : '') + "\n            ")]
      }
    }, {
      key: "termino",
      fn: function(row) {
        return [_vm._v("\n              " + _vm._s(row.value ? _vm.$moment(row.value, 'YYYY-MM-DD HH:mm:ss.SSS').format('L HH:mm:ss') : '') + "\n            ")]
      }
    }, {
      key: "observacao",
      fn: function(row) {
        return [(row.value && String(row.value).trim().length) ? _c('span', [_vm._v("\n                " + _vm._s(row.value) + "\n              ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("\n                —\n              ")])]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [(row.item.termino !== null) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button",
            "disabled": false
          },
          on: {
            "click": function($event) {
              _vm.showModal = true, _vm.testFunc(row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-search",
          attrs: {
            "aria-hidden": "true"
          }
        })]) : _vm._e()], 1)]
      }
    }])
  }), _vm._v(" "), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.historicoGridItems.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.showModal) ? _c('div', [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        return _vm.$emit(_vm.showModal = false)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Histórico")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_nome),
      expression: "snap.ds_nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "companyName",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('the-mask', {
    staticClass: "form-control",
    attrs: {
      "name": "cnpj",
      "type": "text",
      "disabled": "true",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.snap.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ds_cnpj", $$v)
      },
      expression: "snap.ds_cnpj"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "dt_cnpj"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    attrs: {
      "name": "cnpjExpeditionTime",
      "use-utc": true,
      "input-class": "form-control",
      "language": _vm.$datePickerPtBR,
      "format": "dd/MM/yyyy",
      "disabled": "true"
    },
    model: {
      value: (this.snap.dt_data_expedicao_cnpj),
      callback: function($$v) {
        _vm.$set(this.snap, "dt_data_expedicao_cnpj", $$v)
      },
      expression: "this.snap.dt_data_expedicao_cnpj"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "businessName"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_nome_fantasia),
      expression: "snap.ds_nome_fantasia"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "businessName",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.ds_nome_fantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_nome_fantasia", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "legalType"
    }
  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaFormasJuridicas,
      "multiple": false,
      "disabled": true,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma Natureza Jurídica",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaListaFormaJuridica,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "forma_juridica"
    },
    model: {
      value: (_vm.snap.forma_juridica),
      callback: function($$v) {
        _vm.$set(_vm.snap, "forma_juridica", $$v)
      },
      expression: "snap.forma_juridica"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "activity"
    }
  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaRamosAtividade,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "disabled": true,
      "preserve-search": true,
      "placeholder": "Selecione os Ramos de Atividade",
      "label": "ds_codigo",
      "track-by": "ds_codigo",
      "custom-label": _vm.etiquetaListaRamosAtividade,
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "ramos_atividade"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }], null, false, 2912667078),
    model: {
      value: (_vm.snap.ramos_atividade),
      callback: function($$v) {
        _vm.$set(_vm.snap, "ramos_atividade", $$v)
      },
      expression: "snap.ramos_atividade"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "constitutionDocument"
    }
  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaDocConstituicao,
      "multiple": false,
      "close-on-select": true,
      "searchable": false,
      "disabled": true,
      "track-by": "id",
      "label": "ds_tipo",
      "placeholder": "Selecione um Documento de constituição",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "listaDocConstituicao"
    },
    model: {
      value: (_vm.snap.documento_constituicao),
      callback: function($$v) {
        _vm.$set(_vm.snap, "documento_constituicao", $$v)
      },
      expression: "snap.documento_constituicao"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6",
    attrs: {
      "id": "contato"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.contato.ds_telefone),
      expression: "snap.contato.ds_telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ####-#####'),
      expression: "'(##) ####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "phone",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.contato.ds_telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap.contato, "ds_telefone", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.contato.ds_celular),
      expression: "snap.contato.ds_celular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) #####-#####'),
      expression: "'(##) #####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "mobile",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.contato.ds_celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap.contato, "ds_celular", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_email),
      expression: "snap.ds_email"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "email",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.ds_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snap.ds_website),
      expression: "snap.ds_website"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "website",
      "type": "text",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.snap.ds_website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.snap, "ds_website", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])]), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.histEndereco,
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])]), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.histDirigente,
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuários:")])])]), _vm._v(" "), _c('usuarios', {
    attrs: {
      "entUsuarios": _vm.histUsuario,
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.histDocumento,
      "documentTypes": '',
      "disable": _vm.disable,
      "local-uso": 'TODOS'
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('br'), _vm._v(" "), _c('b-button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button",
      "disabled": false
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Fechar ")])], 1)])])])])])])])])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('pre', {
    ref: "myDiv",
    attrs: {
      "id": "myDiv"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37f1f8a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/historico-entidade.vue
// module id = 1907
// module chunks = 1